import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useMix');

    return {
        ARCHIVE_FAILED: t('archiveFailed'),
        CONNECTION_ERROR: t('connectionError'),
        SAVE_FAILED: t('saveFailed')
    };
};

export default useTranslation;
